export enum PermissionType {
    SAVE = 'saveFlag',
    UPDATE = 'updateFlag',
    DELETE = 'deleteFlag',
    VIEW = 'viewFlag',
    PRINT = 'printFlag',
}
